import { Component, effect, forwardRef, Inject, inject, input, Input, output, ViewEncapsulation } from '@angular/core';
import { JSBridgeService } from '../jsbridge.service';
import { JSBridge } from '@wasm/KopWeb';
import { KopConfigService } from '../kop-config.service';
import { LDMenuService } from '../ldmenu.service';
import { ModulesRepoService } from '../../modules/modules-repo.service';
import { KopModulesService } from '../../modules/kop-modules.service';
import { ValidationService } from '../../modules/validation.service';
import { KanaalService } from '../../kanaal/kanaal.service';
import { MetaService } from '../meta.service';
import { PropsServiceService } from '../../props/props-service.service';
import { PcibService } from '../pcib.service';
import { KopListService } from '../kop-list.service';
import { HwdConfigService } from '../../kanaal/hwd-config.service';
import { AutosaveService } from '../autosave.service';
import { TranslateService } from '../../i18n/translate.service';
import { LegacyListService } from '../../legacy-list.service';
import { ServerAPI } from '../../serverapi';

@Component({
  selector: 'kop-config',
  inputs: ['klantNo'],
  providers: [
    {
      provide: JSBridgeService,
      useClass: JSBridgeService,
    }, KopConfigService, LDMenuService, ModulesRepoService, KopModulesService, ValidationService, KanaalService, MetaService, PropsServiceService, 
    PcibService, KopListService, HwdConfigService, AutosaveService, LegacyListService,
    {
      provide: 'i18n-label',
      useValue: 'KopConfigComponent'
    }
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './kop-config.component.html',
  styleUrl: './kop-config.component.scss'
})
export class KopConfigComponent {

  @Input({}) klantNo: string = "xx";

  constructor(@Inject('ServerApi') public electronAPI: ServerAPI) { 
    effect(() => {
      let isKopValid = this.jsBridgeService.isVersionSupported();
      let version = this.jsBridgeService.version();
      if (version != undefined && !isKopValid) {
        this.onInvalidKop.emit(true);
      }
    })
  }

  public jsBridgeService: JSBridgeService = inject(JSBridgeService);
  public jsBridge: JSBridge | undefined;
  public kopConfigService: KopConfigService = inject(KopConfigService);

  ngOnInit() {
    this.jsBridgeService.getBridge().subscribe(bridge => {
      this.jsBridge = bridge;
    });

    this.jsBridgeService.initKlantNo(this.klantNo);
  }

  public onInvalidKop = output<boolean>();

}
